import {NextSeo} from 'next-seo';

import BlogHeader from 'components/BlogHeader';
import BlogPostTile from 'components/BlogPostTile';
import {getArticleSlug} from 'utils/blog';
import {urlFor} from 'utils/sanity.image';

const AuthorHome = ({author}) => {
  const formattedPosts = author.posts.map(post => ({
    ...post,
    link: post.isMarkdown ? post.link : getArticleSlug(post.slug, post.publishedAt),
    image: post.isMarkdown
      ? post.image
      : !post.mainImage?.asset?._ref
      ? null // eslint-disable-line @typescript-eslint/indent
      : urlFor(post.mainImage.asset._ref).url(), // eslint-disable-line @typescript-eslint/indent
  }));

  return (
    <>
      <NextSeo
        title={`Articles by ${author.name as string} | Polar Signals Blog`}
        description={`Articles by ${author.name as string} | Polar Signals Blog`}
        openGraph={{
          title: `Articles by ${author.name as string} | Polar Signals Blog`,
          type: 'author',
        }}
      />
      <BlogHeader title={author.name} subTitle={`Articles by ${author.name as string}`} />

      <div className="container mx-auto my-20 px-4">
        <div className="grid grid-cols-1 gap-6 text-white lg:grid-cols-2">
          {formattedPosts.map((post, index) => (
            <BlogPostTile key={post.link} post={post} index={index} isAuthorPage={true} />
          ))}
        </div>
      </div>
    </>
  );
};

export default AuthorHome;
